import React, { useState } from 'react';
import { auth, waitForAuthReady, functions } from '../../../firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import { useOnboarding } from '../OnboardingContext';

export default function StepSignup({ onNext }) {
  const { state } = useOnboarding();
  const { merge } = useOnboarding();
  const [email, setEmail] = useState(state.ownerEmail || '');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [provisioning, setProvisioning] = useState(false);

  // Clear password and try to avoid autofill by using autocomplete attributes.
  // Also blur any focused element after a short delay to reduce browser autofill behavior.
  React.useEffect(() => {
    setPassword('');
    const t = setTimeout(() => { try { document.activeElement && document.activeElement.blur(); } catch (e) {} }, 50);
    return () => clearTimeout(t);
  }, []);

  const handleSignup = async () => {
    setError('');
    try {
  await createUserWithEmailAndPassword(auth, email.trim().toLowerCase(), password);
  // ensure user is signed in
  await signInWithEmailAndPassword(auth, email.trim().toLowerCase(), password);
  // store owner email in onboarding state (do not store password)
  try { merge({ ownerEmail: email.trim().toLowerCase() }); } catch (e) { /* ignore */ }
  // wait for the auth state to settle before proceeding (avoids race conditions)
  try { await waitForAuthReady(); } catch (e) { /* ignore */ }
  // After signup, attempt to provision tenant immediately using onboarding state
  try {
    const provision = functions ? httpsCallable(functions, 'provisionTenant') : null;
    if (provision) {
      setProvisioning(true);
      // Build the payload from onboarding state (best-effort)
      const payload = {
        companyName: state.company?.name || state.company?.companyName || 'My Company',
        locations: state.locations || [],
        roles: state.roles || [],
        departments: state.departments || [],
        people: state.people || [],
  ownerEmail: state.ownerEmail,
  ownerFirstName: state.ownerFirstName || null,
  ownerLastName: state.ownerLastName || null,
        settings: { hours: state.hours || {} },
      };

      // Retry with backoff (best-effort quick attempts)
      let attempt = 0;
      const maxAttempts = 2;
      while (attempt < maxAttempts) {
        try {
          await provision(payload);
          break; // success
        } catch (fnErr) {
          attempt += 1;
          console.warn('provisionTenant callable failed during signup (attempt', attempt, '):', fnErr);
          if (attempt < maxAttempts) {
            const waitMs = 200 * Math.pow(2, attempt - 1);
            // small sleep
            // eslint-disable-next-line no-await-in-loop
            await new Promise((r) => setTimeout(r, waitMs));
            continue;
          }
          // Exhausted retry attempts; do not attempt client-side tenant writes in production.
          console.warn('Exhausted provision attempts during signup; aborting client-side fallback (server-only provisioning expected).');
        }
      }
      setProvisioning(false);
    }
  } catch (provisionErr) {
    setProvisioning(false);
    console.warn('Provision attempt after signup failed:', provisionErr);
  }

  onNext();
    } catch (err) {
      console.error('Signup error', err);
      setError(err.message || 'Signup failed');
    }
  };

  return (
    <div style={{padding:24}}>
      <h3>Create your account</h3>
      <input autoComplete="email" name="onboarding-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <input autoComplete="new-password" name="onboarding-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
      {error && <div style={{color:'red'}}>{error}</div>}
      <div style={{marginTop:12}}>
  <button onClick={handleSignup} disabled={!email || !password || provisioning}>{provisioning ? 'Creating...' : 'Create account'}</button>
      </div>
    </div>
  );
}
